const configQueryReactCodetable = {
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    refetchOnReconnect: true,
};

export const configQueryReactSimpleRequest = {
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    refetchOnReconnect: true,
    keepPreviousData: false,
};
export default configQueryReactCodetable;